import { Fight } from '../models/fight.model';
import { Season } from '../models/season.model';

// First check if there are any fights for this season
export const checkSelectedSeasonFights = (
  seasons: Season[],
  allFights: Fight[],
  seasonId: string,
) => {
  // Return false if we don't have the necessary data
  if (!seasons || !allFights || !seasonId) {
    return false;
  }

  // Return false if arrays are empty
  if (seasons.length === 0 || allFights.length === 0) {
    return false;
  }

  const selectedSeason = seasons.find((season) => season.seasonId === seasonId);

  // If season not found, return false
  if (!selectedSeason) {
    return false;
  }

  // Check if there are any fights within this season's date range
  const seasonStartDate = new Date(selectedSeason.startDate);
  const seasonEndDate = new Date(selectedSeason.endDate);

  // Return false if dates are invalid
  if (isNaN(seasonStartDate.getTime()) || isNaN(seasonEndDate.getTime())) {
    return false;
  }

  const fightsInSeason = allFights.some((fight) => {
    const fightDate = new Date(fight.date);
    return fightDate >= seasonStartDate && fightDate <= seasonEndDate;
  });

  return fightsInSeason;
};
